module.exports = __webpack_public_path__ + "fonts/garet-fat.605bc078.ttf";